import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";

interface DetailsContentProps {
  heading?: string;
  content: React.ReactNode;
  loading?: boolean;
  hideHeading?: boolean;
  wrapperStyle?: React.CSSProperties;
}
function DetailsContent(props: DetailsContentProps) {
  const { heading, content, hideHeading, wrapperStyle } = props;
  return (
    <Flex vertical space="4" align='flex-start' style={{ ...wrapperStyle }} >
      <HideWrapper hide={Boolean(hideHeading)}>
        <TypographyText style={{ color: "var(--gray-7)" }}>
          {heading}
        </TypographyText>
      </HideWrapper>
      {content}
    </Flex>
  );
}

export { DetailsContent };
